module.exports = __webpack_public_path__ + "static/media/aspo_olbia.badeb958.svg";